
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Ezt a
                    <a href="${0}">Folksonomy Engine projekt</a>hozta el. Ne
                    habozz részt venni vagy visszajelzést adni.`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Ez az eszköz lehetővé teszi az összetevők listájának javítását. Hozzáadhat, eltávolíthat vagy szerkeszthet
                összetevőlistát.
                <br>
                Ez a karakter <span class="highlight">␣</span> szóközt jelöl.
                <br>
                Ez a karakter <span class="highlight">↩︎</span> sortörést jelöl. `,
'hb28f1f2ec1744ee9': html`These properties are created and filed by users for any kind of usages. Feel
                    free to add your own. The properties and values you create
                    <strong>must be factual</strong>. You can dive into
                    <a href="${0}">the list of properties already used by the community</a>
                    or explore the
                    <a href="${1}">properties' documentation and its search engine</a>.`,
's000a5b76bd3a01c2': `Tulajdonságok betöltése...`,
's000d98595e959c1e': `Elérhető a Google Playen`,
's013bdc8cf0d3583d': `Segíts nekünk az alapanyagokkal`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Növény validálása`,
's03e9c8114521b998': `Szerkesztem a hozzávalókat`,
's05ec315d9308091a': `Vonalkód sarkok ikon`,
's061eb5af92512c85': `Mentve! Tudsz segíteni egy újabbal?`,
's06847c221c4c0bc1': `Szeretnék létrehozni egy tulajdonságot a [használati eset leírására]...`,
's06f6c6f99db6b552': `Eredeti`,
's081e2ad82db71e1d': `Csoportosított értékek`,
's09205907b5b56cda': `Nem`,
's0b4235aae602a950': `dedikált dokumentáció`,
's0bb2d48532acc455': `CSV letöltése`,
's0d5b7fee0311db68': `Tulajdonság`,
's0fb218abc2e157ed': `Kép érvénytelenítése`,
's100c4928cc74642a': `a közegészségügyi kutatás előmozdításának támogatása.`,
's10db5498186c083b': `Vágás megszakítása`,
's11a18a69b30b65ed': `Segítsen nekünk kijavítani az összetevők listájában található hibákat`,
's1205d5f6fccf8e69': `Ingatlan értéke`,
's15d64a0a6715285a': `Új kulcs`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `Kijelölési terület`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Segítsen nekünk a tápértékadatok helyesbítésében`,
's1e00019dc454872d': `Kérjük, adjon meg egy tulajdonságnevet a property-name attribútum használatával.`,
's1e49126af0935a5b': `Az ezt a tulajdonságot használó termékek listája`,
's21e73088de6f26f3': `Letölthető az App Store-ból`,
's255857544a9d5ec0': `Visszaállítás`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Mégse`,
's2db7b654c0a9bde0': `Dokumentálja az ingatlant`,
's300b3a6ee4e1252d': str`Gyenge egyezés ${0}%`,
's33f786bb6b4f0cf4': `Terméseredmény`,
's33f85f24c0f5f008': `Mentés`,
's34be4af4e8fec4ae': `Először kérdezd meg a közösséget`,
's36d86adc823cbfa6': `Új ingatlan létrehozása előtt beszélje meg a közösséggel:`,
's3781d25aa51a736c': `Folksonomy Engine dokumentáció`,
's383ae4449428b61e': `Körülvágás visszaállítása`,
's39bcf88721a1e8ee': `Kijelölés visszaállítása`,
's39e14e14300694c7': `Dokumentáció és irányelvek`,
's3b430cfa5c1fe7f4': str`Dokumentáció a ${0}-hoz`,
's3f4e4b52f230a892': `Képvászon`,
's417b90913e05bc17': `Előnézet`,
's41f7dca46d3f1b4a': `Érték`,
's422bba9636ce2489': `Középre helyezett kép`,
's42dd66b2441566fd': `Középső ikon`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Tápanyag hozzáadása`,
's453ab0dbb9b5c777': `Átméretezés jobbra`,
's475b08749d0706ed': `Segítsen nekünk tájékoztatni a fogyasztók millióit világszerte arról, hogy mit esznek`,
's49730f3d5751a433': `Betöltés…`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Termékszám`,
's4df2f533c0c1e7d0': `Képvezérlők`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Kijelölés mozgatása`,
's4f751fb9b3ed766c': `Új ingatlan létrehozása`,
's547c12ae169d00bc': `Elérhető F-Droidon`,
's5560fb119e40923d': `Adja meg a tulajdonság nevét...`,
's55d7249883a98ca1': `erről a szálláshelyről az Open Food Facts wikin`,
's565867d84c04aea2': `Szűrő tulajdonságai...`,
's5666afe5cd0166de': `Kérjük, javítsa ki a hibákat, vagy módosítsa a szöveget a megerősítés előtt.`,
's57472465a23b41db': `Értékek`,
's58e1eeea7a60ae51': `Termékek betöltése...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Segítsen nekünk a tápértéktáblázat helyesbítésében.`,
's5dd6f12783fca34f': `Összetevők listájának szerkesztése`,
's5e8250fb85d64c23': `Bezárás`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `TÁMOGATOM`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Szerkesztés`,
's66413c24dcf680e2': `Kihagyás`,
's67ae6594857a4d57': `Köszönjük a közreműködést!`,
's6cee7cad81dfedd1': `Vágott kép`,
's6d7b6cdedaadfb6e': `Minden adomány számít! Nagyra értékeljük az élelmiszerek globális átláthatóságának javításáért nyújtott támogatását.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Jó egyezés ${0}%`,
's71a5c9f4b68ef4d4': `Mennyiség`,
's74cb3d66f6a668e1': `Dokumentáció`,
's787dd11bed0dc88a': `Átméretezés balra`,
's7ce4fd9430e80cea': `érték`,
's801a05fa8e881f37': `Tudjon meg többet az ingatlanok létrehozásáról és az irányelvekről:`,
's8038273de2cf8b73': `Kérjük, válasszon ki egy régiót a kivágáshoz.`,
's839cc2908a5387f2': `Vonalkódok szűrése...`,
's86197dcf3e96af64': `Böngésszen és keressen meglévő ingatlanokat`,
's8a63be30a129a59c': `Alsó méret átméretezése`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Jobb felső rész átméretezése`,
's8db84aa4bc949af2': `Dokumentálja az új ingatlant`,
's8f839a03997a16d7': `Termék megtekintése`,
's901ae1e236ac45d3': `Törlés visszavonása`,
's907f7a97c6b29425': `Kérjük, vegye figyelembe, hogy az adatmodell módosulhat. Használja saját felelősségére.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Hozzávalók:`,
's9a7f60fce090ecaf': `Nem sikerült betölteni a tulajdonságokat. Próbálja újra később.`,
's9b87abd68fb9df45': `Nem találod? Hozz létre új kulcsot {value}`,
's9c0f52425fd2f07e': `Lehet, hogy nem egyezik`,
's9fc41f789c63b40d': `Termékek`,
'sa1fa766e0d5634d7': `Nincs elérhető pontszám`,
'sa548778b24054030': `Fedezze fel a Folksonomy Engine projekt összes hozzáadott tulajdonságát. Ezek a tulajdonságok további metaadatokat és információkat nyújtanak az Open Food Facts adatbázisban található termékekről.`,
'sa63907958bd0ec4b': `Bal felső rész átméretezése`,
'sa95b4224f685a36a': `Modális ablak bezárása`,
'sab56a1d439576fd6': `Javaslat ikon`,
'sac47ea2901d04c15': `Bal alsó rész átméretezése`,
'sb125227d436c2925': `Keresse meg az ingatlankoncepcióját a meglévő ingatlanadatbázisban:`,
'sb125568d43642e6f': `Válaszoljon a termékkel kapcsolatos kérdésekre.`,
'sb1c538e038f9b214': str`Nagyon jó egyezés ${0}%`,
'sb28639570ff3b852': `az összes ingatlan listája`,
'sb3bdd638a58d30f4': `elkötelezett állampolgárok közösségének bevonása,`,
'sb3cbcc1bd0fff140': `Miután ellenőrizted, hogy a tulajdonságod nem létezik, és a közösség egyetért azzal, hogy hasznos, először dokumentálnod kell a wikin.`,
'sb3d4f79d9d8b71e5': `Elküldés`,
'sb560fa37a7bfb6c2': `Nem találhatók termékek ehhez az ingatlanhoz.`,
'sb7f72e4c8a2d3357': `Értékek szűrése...`,
'sb8178320160f84ea': `Vágás megjelenítése`,
'sbad7d2734149470b': `Érvényesítés`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `Minden meglátásra választ kaptam! Köszönöm a segítséget!`,
'sbd9a0b2293b3cd3c': `Adag`,
'sbe472dc3c2685985': `Megfelelő érték`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Felső méretének átméretezése`,
'sc1c08d0cbcc3bd24': `Nem egyezik`,
'sc52696641af72b53': `Telepítse az alkalmazást!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Javasolt javítás`,
'sc681b137e8f604f7': `Törlés megerősítése`,
'sc6daf8a31883f8b9': `Kép áthelyezése`,
'sc895972c88d38ca5': `Folksonomy tulajdon`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Sorok`,
'scb3b0671d7b7f640': `Új érték`,
'scb489a1a173ac3f0': `Igen`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Csatlakozz a Slack-beszélgetéshez`,
'scdb6cad0b92721bf': `Nem találhatók ingatlanok.`,
'scf23a05631f93732': `Törlés megerősítése`,
'scfed2f270ef6a3aa': `Válasszon területet`,
'sd1022bc1ef9204f7': `Nagyítható kép`,
'sd1077c055cf9ba6b': `Segítsen nekünk ellenőrizni a termék összetevőlistáját.`,
'sd698d21ddecba56b': `Szia! A következő kérdések megválaszolásával segíthetsz nekünk a termékinformációk fejlesztésében:`,
'sd82bc2decefa621b': `függetlennek maradni az élelmiszeripartól,`,
'sdb97e5976482606e': `Ellenőrizd, hogy létezik-e már egy tulajdonság`,
'sdbf806fefc584115': `Találnod kellene egy`,
'sdc673e73b5c13aea': `Törlés`,
'sdc792b75f1edcaba': `Segíts nekünk kijavítani az összetevők helyesírását.`,
'sdca5deead576ceee': `Jobb alsó méretezése`,
'sdcc2555c5dde524f': `Biztosan törölni szeretné ezt az elemet? Ez a művelet nem vonható vissza.`,
'se206feec7ec57b28': `100g-ra`,
'se419a9ab36987490': `Érvénytelenít`,
'se5127cf0f92e7e48': `Tipp: itt is megtalálhatod a`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Jobb termést fogok javasolni`,
'seea3800e27baa686': `Egyedi termékek`,
'sefaba4adc4ec9219': `Folksonomy Properties`,
'seffa8ca49175b5f0': `Személyre szabott tulajdonságok`,
'sf44a6b3b232c28ea': str`Cserélje ki az aktuális értéket ${0}-ra`,
'sf4cd86a2f5ef2588': `Termék vonalkód`,
'sf57a61152168cc81': `Segítsen nekünk az összetevők észlelésének javításában`,
'sf88b90b8ba23871c': `Ismeretlen egyezés`,
'sf9aee319a006c9b4': `Hozzáadás`,
'sfacbbe968fa7d773': `Ingatlan neve:`,
'sfc40ea3d5d5aa6f8': `Adományaival nonprofit egyesületünk mindennapi működését finanszírozza:`,
'sfe87465d50530725': `Megfelelő érték`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  